import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;

  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 24px 16px;
  box-sizing: border-box;
`

export const Title = styled.label`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const SubTitle = styled.label`
  color: var(--Foreground-Neutral-faded, #4d5874);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const SwitchContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const SwitchLabel = styled.div`
  color: var(--Foreground-Neutral-faded, #4d5874);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const SelectedPictureLabel = styled.div`
  color: var(--Text-Secondary, #4d5874);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
`
